import { Controller } from "@hotwired/stimulus"
import { ModalScrollFix } from "util/modal";
import { ModalFocus } from "util/focus";
const classes = require("util/classes")(__filename)

export default class extends Controller {
  static targets = ["modal"]
  showing = false

  connect() {
    this.scrollFix = new ModalScrollFix()
    this.focus = new ModalFocus()
    this.show()
  }

  disconnect() {
    this.hide()
  }

  onCloseClick() {
    this.hide()
  }

  onOverlayClick(event) {
    if (this.modalTarget.contains(event.target)) return
    this.hide()
  }

  onBodyKeyup(event) {
    if (event.key !== "Escape") return
    this.hide()
  }

  hide() {
    if (!this.showing) return
    this.showing = false
    this.scrollFix.unfix()
    this.element.classList.add(classes("hide"))
    this.focus.restore()
  }

  show() {
    this.showing = true
    this.scrollFix.fix()
    this.element.classList.remove(classes("hide"))
    this.focus.moveInto(this.modalTarget)
  }
}
